import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";

export default function Treatments() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Seo title="Treatments | Psalm 30:2 Chiropractic — Gardner, KS" description="Chiropractic care, myofascial release, functional movement, SoftWave, dry needling, pediatric and perinatal care in Gardner, Kansas." />
      <PageHero
        eyebrow="Our Treatments"
        title={<>Every treatment,<br />a considered choice.</>}
        intro="Every treatment we offer is a way of communicating with your nervous system — changing the input it receives so tension, guarding and pain can settle. Each tool is selected for your assessment and goals, and always integrated into a bigger picture."
      />
      <section className="bg-ivory pb-28 px-6 md:px-10 lg:px-14" data-testid="treatments-grid">
        <div className="max-w-[1500px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 70}>
              <Link to={`/treatments/${s.slug}`} className="group block" data-testid={`treatment-card-${s.slug}`}>
                <div className="overflow-hidden rounded-sm aspect-[4/3] mb-5">
                  <img src={resolveImg(s.image)} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
                </div>
                <div className="overline mb-2">{s.category}</div>
                <h3 className="font-serif text-2xl lg:text-3xl text-espresso group-hover:text-taupe transition-colors">{s.name}</h3>
                <p className="mt-2 text-espressosoft/70 font-light leading-relaxed">{s.tagline}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
